import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-water',
  templateUrl: './water.component.html',
  styleUrls: ['./water.component.scss']
})
export class WaterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
